import React, { ComponentPropsWithRef, FC } from 'react';
import classnames from 'classnames';
import styles from './HorizontalSeparator.module.scss';

type Props = ComponentPropsWithRef<'div'>;

const HorizontalSeparator: FC<Props> = ({ className, ...rest }) => {
  const rootClass = classnames(styles['horizontal-separator'], className);
  return <div className={rootClass} {...rest} />;
};

export { HorizontalSeparator };
